import { TPackageId } from '../../api';

export interface ICheckoutState {
  /** Признак видимости переключателя согласия списания суммы с баланса */
  isUseBalanceFundsVisible: boolean;
  /** Признак согласия списания суммы с баланса в счёт оплаты */
  isUseBalanceFunds: boolean;
  /** Сумма пополнения или стоимость продукта */
  price: number;
  /** «Спишем с баланса» в чекауте */
  balance: number;
  /** «Итого к оплате» в чекауте */
  totalAmount: number;
  /** Сумма, которая будет в итоге списана с баланса */
  paymentAmount: number;
  /** Тип покупаемого продукта */
  productType: EProductType | null;
  /** Точка входа, из которой была вызвана оплата */
  paymentInitSource: EPaymentInitSource | null;
  /** ID транзакции при холдировании */
  transactionId: string | undefined;
  /** ID пакета или подписки для аналитики */
  packageId: TPackageId;
}

export const enum EProductType {
  Package = 'package',
  Subscription = 'subscription',
}

export enum EPaymentInitSource {
  /** Рекомендованный пакет */
  LkRealtorPackage = 'packageLkRealtor',
  /** Конструктор  */
  LkRealtorCustomPackage = 'customPackageLkRealtor',
  /** Подписка  */
  LkRealtorSubscription = 'subscriptionLkRealtor',
  /** Персональный пакет */
  LkRealtorPersonalPackage = 'personalPackageLkRealtor',
  /** Персональная подписка  */
  LkRealtorPersonalSubscription = 'personalSubscriptionLkRealtor',
  /** Смарт-пакет  */
  LkRealtorSmartPackage = 'smartPackageLkRealtor',
  /** Пополнение в сайд-баре лк соба  */
  LkOwnerDeposit = 'depositLkHomeowner',
  /** Пополнение в лк риелтора  */
  LkRealtorDeposit = 'depositLkRealtor',
  /** Платёж для идентификации по карте в лк соба */
  LkOwnerIdentification = 'lkHomeownerIdentification',
  /** Платёж для идентификации по карте в лк риелтора */
  LkRealtorIdentification = 'identificationLkRealtor',
  /** Платёж для идентификации по карте на ФП */
  AddFormIdentification = 'publishObjectIdentification',
  /** Пополнение на форме подачи */
  AddFormDeposit = 'publishObject',
}
